import {
  FETCH_USERS,
  SET_USERS,
  SET_USERS_FAILURE,
  ADD_USER,
  ADD_USER_SUCCESS,
  ADD_USER_FAILURE,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  BULK_ACTION_USERS,
  BULK_ACTION_USERS_SUCCESS,
  BULK_ACTION_USERS_FAILURE,
  RESET_USER_PASSWORD,
  RESET_USER_PASSWORD_SUCCESS,
  RESET_USER_PASSWORD_FAILURE,
  TOGGLE_TWO_FACTOR,
  TOGGLE_TWO_FACTOR_SUCCESS,
  TOGGLE_TWO_FACTOR_FAILURE,
  GET_USER_ACCESS,
  SET_USER_ACCESS,
  SET_USER_ACCESS_FAILURE,
  UPDATE_USER_ACCESS,
  UPDATE_USER_ACCESS_SUCCESS,
  UPDATE_USER_ACCESS_FAILURE,
  SAVE_USER_ACCESS,
  SAVE_USER_ACCESS_SUCCESS,
  SAVE_USER_ACCESS_FAILURE,
  RESTORE_USER_ACCESS,
  RESTORE_USER_ACCESS_SUCCESS,
  RESTORE_USER_ACCESS_FAILURE,
  GET_USER_ACCESS_PERMISSIONS,
  SET_USER_ACCESS_PERMISSIONS,
  SET_USER_ACCESS_PERMISSIONS_FAILURE
} from '../types';

// Fetch Users
export const fetchUsers = (filters = {}) => ({
  type: FETCH_USERS,
  filters
});

export const setUsers = (users) => ({
  type: SET_USERS,
  users
});

export const setUsersFailure = (error) => ({
  type: SET_USERS_FAILURE,
  error
});

// Add User
export const addUser = (userData, currentUser) => ({
  type: ADD_USER,
  userData,
  currentUser
});

export const addUserSuccess = (user) => ({
  type: ADD_USER_SUCCESS,
  user
});

export const addUserFailure = (error) => ({
  type: ADD_USER_FAILURE,
  error
});

// Update User
export const updateUser = (userData, currentUser) => ({
  type: UPDATE_USER,
  userData,
  currentUser
});

export const updateUserSuccess = (user) => ({
  type: UPDATE_USER_SUCCESS,
  user
});

export const updateUserFailure = (error) => ({
  type: UPDATE_USER_FAILURE,
  error
});

// Delete User
export const deleteUser = (userId, currentUser) => ({
  type: DELETE_USER,
  userId,
  currentUser
});

export const deleteUserSuccess = (userId) => ({
  type: DELETE_USER_SUCCESS,
  userId
});

export const deleteUserFailure = (error) => ({
  type: DELETE_USER_FAILURE,
  error
});

// Bulk Actions
export const bulkActionUsers = (bulkAction, currentUser) => ({
  type: BULK_ACTION_USERS,
  bulkAction,
  currentUser
});

export const bulkActionUsersSuccess = (result) => ({
  type: BULK_ACTION_USERS_SUCCESS,
  result
});

export const bulkActionUsersFailure = (error) => ({
  type: BULK_ACTION_USERS_FAILURE,
  error
});

// Reset Password
export const resetUserPassword = (email, ttlSeconds, platform) => ({
  type: RESET_USER_PASSWORD,
  email,
  ttlSeconds,
  platform
});

export const resetUserPasswordSuccess = (email) => ({
  type: RESET_USER_PASSWORD_SUCCESS,
  email
});

export const resetUserPasswordFailure = (error) => ({
  type: RESET_USER_PASSWORD_FAILURE,
  error
});

// Toggle Two Factor
export const toggleUserTwoFactor = (userId, currentUser) => ({
  type: TOGGLE_TWO_FACTOR,
  userId,
  currentUser
});

export const toggleUserTwoFactorSuccess = (userId, twoFactorEnabled) => ({
  type: TOGGLE_TWO_FACTOR_SUCCESS,
  userId,
  twoFactorEnabled
});

export const toggleUserTwoFactorFailure = (error) => ({
  type: TOGGLE_TWO_FACTOR_FAILURE,
  error
});

// User Access Permissions Actions
export const getUserAccess = () => ({
  type: GET_USER_ACCESS
});

export const setUserAccess = (rolePermissions) => ({
  type: SET_USER_ACCESS,
  rolePermissions
});

export const setUserAccessFailure = (error) => ({
  type: SET_USER_ACCESS_FAILURE,
  error
});

export const updateUserAccess = (role, permissionId, checked) => ({
  type: UPDATE_USER_ACCESS,
  role,
  permissionId,
  checked
});

export const updateUserAccessSuccess = () => ({
  type: UPDATE_USER_ACCESS_SUCCESS
});

export const updateUserAccessFailure = (error) => ({
  type: UPDATE_USER_ACCESS_FAILURE,
  error
});

export const saveUserAccess = (rolePermissions, updatedBy) => ({
  type: SAVE_USER_ACCESS,
  rolePermissions,
  updatedBy
});

export const saveUserAccessSuccess = () => ({
  type: SAVE_USER_ACCESS_SUCCESS
});

export const saveUserAccessFailure = (error) => ({
  type: SAVE_USER_ACCESS_FAILURE,
  error
});

export const restoreUserAccess = () => ({
  type: RESTORE_USER_ACCESS
});

export const restoreUserAccessSuccess = (rolePermissions) => ({
  type: RESTORE_USER_ACCESS_SUCCESS,
  rolePermissions
});

export const restoreUserAccessFailure = (error) => ({
  type: RESTORE_USER_ACCESS_FAILURE,
  error
}); 

// User Access Permissions After Login Actions
export const getUserAccessPermissions = (cognitoId) => ({
  type: GET_USER_ACCESS_PERMISSIONS,
  cognitoId
});

export const setUserAccessPermissions = (userPermissions) => ({
  type: SET_USER_ACCESS_PERMISSIONS,
  userPermissions
});

export const setUserAccessPermissionsFailure = (error) => ({
  type: SET_USER_ACCESS_PERMISSIONS_FAILURE,
  error
}); 